import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { ArrowUpCircleIcon } from '@iris/react-icons/ArrowUpCircleIcon';
import { StopCircleIcon } from '@iris/react-icons/StopCircleIcon';
import messageInputButtonStyles from './MessageInputButton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const MessageInputButton = React.forwardRef((_a, ref) => {
    var { variant = "send", inverse = false, disabled = false, className, "aria-label": ariaLabel } = _a, props = __rest(_a, ["variant", "inverse", "disabled", "className", "aria-label"]);
    const { button, icon } = messageInputButtonStyles({
        inverse,
        variant,
        disabled,
    });
    const IconComponent = variant === "send" ? ArrowUpCircleIcon : StopCircleIcon;
    const defaultAriaLabel = variant === "send" ? "Send message" : "Stop AI response";
    return (jsx("button", Object.assign({ tabIndex: 0, ref: ref, disabled: disabled, className: cn(button(), className), "aria-label": ariaLabel || defaultAriaLabel }, props, { children: jsx(IconComponent, { className: icon(), "aria-hidden": "true" }) })));
});
MessageInputButton.displayName = "MessageInputButton";

export { MessageInputButton };
